import { render, staticRenderFns } from "./Food.vue?vue&type=template&id=650d88ea"
import script from "./Food.vue?vue&type=script&lang=js"
export * from "./Food.vue?vue&type=script&lang=js"
import style0 from "./Food.vue?vue&type=style&index=0&id=650d88ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports